"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegacyFetcher = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var react_1 = __importDefault(require("react"));
var legacy_queries_1 = require("../../../../../shared/api/legacy-queries");
var ui_1 = require("../ui");
var utils_1 = require("../utils");
function Data(_a) {
    var _b = __read(_a.data, 2), billingSummary = _b[0].billingSummary, billingPeriodEndDates = _b[1], accountId = _a.props.accountId;
    //@ts-ignore TODO: Handle when latestPeriod is undefined.
    var closingBalance = billingSummary.latestPeriod.data.closingBalance.pounds;
    var latestBalanceDetails = (0, utils_1.getLatestBalanceDetails)(billingPeriodEndDates);
    //@ts-ignore Account Summary UI will continue to use accountId from legacy query
    return (react_1.default.createElement(ui_1.AccountSummaryUI, { balance: closingBalance, accountNo: accountId, latestBalanceDetails: latestBalanceDetails }));
}
var LegacyFetcher = function (_a) {
    var accountId = _a.accountId;
    var latestBillingQueryResult = (0, legacy_queries_1.useBillingLegacyQuery)(accountId, 'latest');
    var billingPeriodEndDates = (0, legacy_queries_1.useBillablePeriodEndDatesLegacyQuery)(accountId);
    return (react_1.default.createElement(ui_tools_1.QueryResultRenderer, { queryResults: [latestBillingQueryResult, billingPeriodEndDates], forwardProps: { accountId: accountId }, NoData: ui_1.Loading, Error: ui_1.Error, Data: Data }));
};
exports.LegacyFetcher = LegacyFetcher;
